import { Actions, PageController } from '@sitecore-search/core';
import { getContainerNode } from './domUtils.js';
let observer;
const start = () => {
    if (observer) {
        return;
    }
    const container = getContainerNode();
    observer = new MutationObserver((mutationsList) => {
        const widgets = [];
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((addedNode) => {
                const rfkId = addedNode.dataset.rfkid;
                const entity = addedNode.dataset.entity;
                if (addedNode.nodeType === Node.ELEMENT_NODE &&
                    (!container || !container.contains(addedNode)) &&
                    rfkId &&
                    entity) {
                    widgets.push({ rfkId, entity, node: addedNode });
                }
            });
        });
        if (Object.keys(widgets).length > 0) {
            PageController.getDispatcher().dispatch({
                type: Actions.FOUND_WIDGETS,
                payload: { widgets },
            });
        }
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
};
const stop = () => {
    observer && observer.disconnect();
};
export default {
    start,
    stop,
};
